import React from "react";

const ContactSection = () => {
  return (
    <section className="bg-gray-100 py-12">
      <div className="container mx-auto px-6">
        <h2 className="text-3xl font-bold text-gray-800 text-center mb-8">İletişim</h2>
        <div className="bg-white rounded-lg shadow-md p-6 grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Sol Kısım: İletişim Bilgileri */}
          <div className="space-y-6">
            <div className="flex items-center space-x-4">
              <div className="p-3 bg-blue-500 text-white rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 10l1.79 1.79a1 1 0 001.42 0L12 5l5.79 5.79a1 1 0 001.42 0L21 10M3 10v10a1 1 0 001 1h16a1 1 0 001-1V10"
                  />
                </svg>
              </div>
              {/* <p className="text-lg text-gray-700">+90 (543) 396 14 20</p> */}
            </div>
            <div className="flex items-center space-x-4">
              <div className="p-3 bg-blue-500 text-white rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M16 8c0-2.209-1.791-4-4-4s-4 1.791-4 4m8 0a8 8 0 01-7 7.93m7-7.93a8.001 8.001 0 00-7-7.93m0 15.86v2.28a2.48 2.48 0 01-2.48 2.48h-3.04a2.48 2.48 0 01-2.48-2.48v-2.28m9 0v-2.28a2.48 2.48 0 012.48-2.48h3.04a2.48 2.48 0 012.48 2.48v2.28"
                  />
                </svg>
              </div>
              <p className="text-lg text-gray-700">info@softrein.com</p>
            </div>
            <div className="flex items-center space-x-4">
              <div className="p-3 bg-blue-500 text-white rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M5.121 17.804A9 9 0 0118.36 4.56m-1.415 1.414a7 7 0 10-9.9 9.9"
                  />
                </svg>
              </div>
              <p className="text-lg text-gray-700">İstanbul, Türkiye</p>
            </div>
          </div>

          {/* Sağ Kısım: İletişim Formu */}
          <div>
            <form className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <input
                  type="text"
                  placeholder="Adınız"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring focus:ring-blue-300"
                />
                <input
                  type="text"
                  placeholder="Soyadınız"
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring focus:ring-blue-300"
                />
              </div>
              <input
                type="email"
                placeholder="E-posta"
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring focus:ring-blue-300"
              />
              <textarea
                rows="4"
                placeholder="Mesajınız"
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring focus:ring-blue-300"
              ></textarea>
              <button
                type="submit"
                className="w-full bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600 transition"
              >
                Gönder
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
